import React, { useState } from 'react';
import {
  Row,
  Col,
  Card,
  Typography,
  Select,
  DatePicker,
  Space,
  Button,
  Tabs,
} from 'antd';
import {
  BarChartOutlined,
  DownloadOutlined,
  ReloadOutlined,
} from '@ant-design/icons';

// Import organized components
import OverviewTab from './components/OverviewTab';
import ExercisesTab from './components/ExercisesTab';
import EquipmentTab from './components/EquipmentTab';
import AdaptationsTab from './components/AdaptationsTab';
import GapsAnalysisTab from './components/GapsAnalysisTab';

// Import data and utilities
import { mockLibraryStats } from './data/mockData';

const { Title } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

const LibraryStatistics: React.FC = () => {
  const [timeRange, setTimeRange] = useState<string>('30d');
  const [dateRange, setDateRange] = useState<any>(null);
  const [activeTab, setActiveTab] = useState<string>('overview');

  const tabItems = [
    {
      key: 'overview',
      label: 'Overview',
      children: <OverviewTab stats={mockLibraryStats} />,
    },
    {
      key: 'exercises',
      label: 'Exercises',
      children: <ExercisesTab />,
    },
    {
      key: 'equipment',
      label: 'Equipment',
      children: <EquipmentTab />,
    },
    {
      key: 'adaptations',
      label: 'Adaptations',
      children: <AdaptationsTab />,
    },
    {
      key: 'gaps',
      label: 'Gaps Analysis',
      children: <GapsAnalysisTab />,
    },
  ];

  return (
    <div>
      <Row gutter={[24, 24]}>
        {/* Header */}
        <Col span={24}>
          <Card>
            <Row justify="space-between" align="middle">
              <Col>
                <Title level={2} style={{ margin: 0 }}>
                  <BarChartOutlined /> Library Statistics
                </Title>
                <Typography.Text type="secondary">
                  Comprehensive analytics and insights across all library components
                </Typography.Text>
              </Col>
              <Col>
                <Space>
                  <Select
                    value={timeRange}
                    onChange={setTimeRange}
                    style={{ width: 120 }}
                  >
                    <Option value="7d">Last 7 days</Option>
                    <Option value="30d">Last 30 days</Option>
                    <Option value="90d">Last 90 days</Option>
                    <Option value="1y">Last year</Option>
                  </Select>
                  <RangePicker
                    value={dateRange}
                    onChange={setDateRange}
                    placeholder={['Start date', 'End date']}
                  />
                  <Button icon={<ReloadOutlined />}>Refresh</Button>
                  <Button icon={<DownloadOutlined />} type="primary">
                    Export Report
                  </Button>
                </Space>
              </Col>
            </Row>
          </Card>
        </Col>

        {/* Main Statistics Tabs */}
        <Col span={24}>
          <Card>
            <Tabs
              activeKey={activeTab}
              onChange={setActiveTab}
              items={tabItems}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default LibraryStatistics; 